<template>
<div class="nftInfo">
<b-container>
    <b-row>
        <b-col cols="12">
            <h2 class="title">THE PLAN</h2>
            <br><br>
            <section id="roadmap" class="container">
            <div class="row justify-content-center">
                <div class="col col-lg-10">
                    <h2 class="range">RANGE PER KILO - $200 to $600</h2>
                    <br><br>
                    <div class="roadmap">
                        <div class="rcontainer">
                            <div class="roadmap-wrapper">
                                <div class="roadmap-item-wrap left scrollflow ">
                                    <div class="roadmap-item left">
                                        <h5 class="list-title">YEAR ONE</h5>
                                        <ul class="roadmap-list">
                                            <li>During the first year of construction and production, there will be NO payout as
                                            there is no production to sell. Bonuses will be paid starting year two and beyond.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="roadmap-item-wrap right scrollflow ">
                                    <div class="roadmap-item right">
                                        <h5 class="list-title">YEAR TWO</h5>
                                        <ul class="roadmap-list">
                                            <li>During the second year, profit per NFT can range between $90 (4.50% APY) to $270 (13.50% APY) annually depending on the sale per kilo.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="roadmap-item-wrap left scrollflow ">
                                    <div class="roadmap-item left">
                                        <h5 class="list-title">YEAR THREE</h5>
                                        <ul class="roadmap-list">
                                            <li>During the third year, profit per NFT can range between $13 (0.67% APY) up to $280 (14% APY) annually depending on the sale per kilo.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="roadmap-item-wrap right scrollflow ">
                                    <div class="roadmap-item right">
                                        <h5 class="list-title">YEAR FOUR</h5>
                                        <ul class="roadmap-list">
                                            <li>During the fourth year, profit per NFT can range between $80 (4% APY) up to $480 (24% APY) annually depending on the sale per kilo.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="roadmap-item-wrap left scrollflow ">
                                    <div class="roadmap-item left">
                                        <h5 class="list-title">YEAR FIVE</h5>
                                        <ul class="roadmap-list">
                                            <li>During the fifth year, profit per NFT can range between $120 (6% APY) up to $600 (30% APY) annually depending on the sale per kilo.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </b-col>
    </b-row>

    <b-row>
        <b-col cols="12">
            <h2 class="title">LEGALITY</h2>
            <br><br>
            <ol>
                <li class="listItem">The goal is total transparency</li>
                <br><li class="listItem">These numbers are not a guarantee. Conditions and markets change.</li>
                <br><li class="listItem">Fiscal year ends December 31 of every year.</li>
                <br><li class="listItem">Payments made first of May every year.</li>
                <br><li class="listItem">Payments are made in ETH, paid to holders of NFTs.</li>
                <br><li class="listItem">Costs to send ETH are the responsibility of Vanilla Holding.</li>
                <br><li class="listItem">Hodlers of the NFT are responsible for their own tax implications in their jurisdictions.</li>
            </ol>
        </b-col>
    </b-row>
</b-container>
<br><br><br><br>
</div>
</template>

<script>
import Chart from './Chart.vue'
export default {
    components:{
        Chart
    }
}
</script>

<style scoped>
.nftInfo
{
    background: #256ea4;
}
.nftImg
{
    width: 100%;
    margin-top: 15vh;
    margin-bottom: 10vh;
    border: 4px solid black;
}

.row1 {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
  margin-top: 10vh;
  margin-bottom: 10vh;
}
.listItem
{
    color: white;
    text-align: left;
    font-size: 3vh;
    font-weight: 500;
}
/* Create two equal columns that sits next to each other */
.column1 {
  flex: 50%;
  padding: 0 2px;
}

.colImg {
  margin-top: 4px;
  vertical-align: middle;
  height: 350px;
  width: 100%;
}
.range
{
    color: white;
    font-size: 3vh;
}
.title
{
    font-family: 'supreme';
    text-align: center;
    font-size: 5vh;
    font-weight: 800;
    margin-top: 10vh;
    color: white;
}
.para
{
    color: white;
    text-align: justify;
    font-size: 2.5vh;
    font-weight: 600;
}




 .roadmap {
	 margin-bottom: 110px;
}
 .roadmap .rcontainer {
	 overflow: hidden;
	 padding-top: 40px;
}
 .roadmap-item .list-title {
	 position: absolute;
	 top: -40px;
	 left: 0;
	 width: 100%;
	 padding-bottom: 18px;
	 font-size: 1.43em;
	 font-weight: 600;
	 border-bottom: 2px solid #333;
	 color: white;
}
 .roadmap-item.executed .list-title {
	 color: #6DECB9;
}
 .roadmap-item.executed li {
	 background: linear-gradient(45deg, #256ea4 23%, #256ea4 33%, #0434da);
	 -webkit-background-clip: text;
	 -webkit-text-fill-color: transparent;
}
 .roadmap-list {
	 padding-top: 20px;
	 font-size: 18px;
	 line-height: 1.6;
	 color: white;
	 padding-left: 0;
}
 .roadmap-list li {
	 position: relative;
	 padding: 0;
	 list-style: none;
	 text-align: left;
}
 .roadmap-list li::before {
	 position: absolute;
	 content: '';
}
 .roadmap-list li:before {
	 width: 30px;
	 height: 100%;
	 left: 0;
	 z-index: 200;
}
 .roadmap-wrapper {
	 position: relative;
	 position: relative;
	 display: flex;
	 flex-direction: column;
}
 .roadmap-wrapper::after {
	 position: absolute;
	 content: '';
}
 .roadmap-wrapper::before {
	 position: absolute;
	 content: '';
}
 .roadmap-wrapper:after, .roadmap-wrapper:before {
	 left: 50%;
	 transform: translateX(-50%);
	 top: 0;
	 height: 100%;
	 width: 2px;
	 z-index: 1;
}
 .roadmap-wrapper:after {
	 background-color: #256ea4;
}
 .roadmap-wrapper:before {
	 background-color: #256ea4;
	 left: calc(50% - 1px);
}
 .roadmap-item-wrap {
	 position: relative;
	 z-index: 10;
}
 .roadmap-item-wrap:after {
	 content: "";
	 display: table;
	 clear: both;
}
 .roadmap-item-wrap .roadmap-item {
	 position: relative;
}
 .roadmap-item-wrap .roadmap-item::before {
	 position: absolute;
	 content: '';
}
 .roadmap-item-wrap .roadmap-item:before {
	 background-repeat: no-repeat;
	 background-position: center;
	 background-size: cover;
	 position: absolute;
	 display: inline-block;
	 line-height: 40px;
	 margin-top: -15px;
	 z-index: 2;
	 color: white;
	 content: ' \25CF';
	 font-size: 30px;
}
 .roadmap-item-wrap.right .roadmap-item {
	 padding-left: 70px;
	 float: right;
}
 .roadmap-item-wrap.right .roadmap-item:before {
	 right: 100%;
	 transform: translateX(50%);
}
 .roadmap-item-wrap.right .list-title {
	 padding-left: 70px;
	 left: auto;
	 right: 0;
}
 .roadmap-item-wrap.left .roadmap-item {
	 padding-right: 70px;
}
 .roadmap-item-wrap.left .roadmap-item:before {
	 left: 100%;
	 transform: translateX(-50%);
}
 .roadmap-item {
	 width: 50%;
}
 @media (max-width: 1200px) {
	 .roadmap-list {
		 font-size: 14px;
	}
	 .token-sale-items-wrapper {
		 left: 40px;
	}
	 .roadmap-item-wrap.left .roadmap-item, .roadmap-item-wrap.right .roadmap-item {
		 padding-right: 35px;
	}
}
 @media (max-width: 992px) {
	 .roadmap-wrapper:before, .roadmap-wrapper:after {
		 display: none;
	}
	 .roadmap-item {
		 width: 100%;
	}
	 .roadmap-item .list-title {
		 position: relative;
		 top: 0;
	}
	 .roadmap-item-wrap {
		 margin-bottom: 25px;
	}
	 .roadmap-item-wrap .list-title {
		 padding-left: 25px !important;
	}
	 .roadmap-item-wrap .roadmap-item {
		 padding: 0 5px 0 0 !important;
	}
	 .roadmap-item-wrap .roadmap-item.right:before, .roadmap-item-wrap .roadmap-item.left:before {
		 width: 30px;
		 height: 30px;
		 margin-left: 0;
		 bottom: 0;
		 top: 1.43em;
		 margin-top: 0;
		 left: 0;
		 right: 100%;
		 line-height: 0;
		 transform: translateX(0px) translateY(0%);
	}
	 .roadmap-list {
		 padding: 14px 0 0 25px;
	}
}
 @media (max-width: 576px) {
	 .roadmap {
		 margin-bottom: 25px;
	}
	 .roadmap .section-title {
		 margin-bottom: 25px;
	}
	 .roadmap-item-wrap {
		 margin-bottom: 21px;
	}
	 .roadmap-item .list-title {
		 font-size: 14px;
		 padding-bottom: 12px;
	}
	 .roadmap-list {
		 font-size: 12px;
		 padding-top: 10px;
	}
	 .roadmap-list li {
		 padding-left: 18px;
	}
	 .roadmap-list li:before {
		 background: url(/assets/img/home/roadmap-list-point.png) no-repeat left 7px;
		 background-size: 4px;
	}
	 .roadmap-item-wrap .roadmap-item:before {
		 width: 35px;
		 height: 35px;
		 top: 10px;
		 left: -4px !important;
	}
	 .roadmap-item-wrap.left .roadmap-item:before {
		 right: -6px;
	}
	 .roadmap-item-wrap.right .roadmap-item:before {
		 left: -6px;
	}
}
 
</style>


// WEBPACK FOOTER //
// src/components/Mobile/Plan.vue